import Button from "components/Button";
import PlaidLinkComponent from "components/PlaidLink";
import Select from "components/Select";
import { IPaymentSpeed } from "models/HaulPay";
import { useState } from "react";
import styles from "./style.module.scss";

type SelectDefaultPaymentSpeedProps = {
  paymentTerms: IPaymentSpeed[];
  selectedPaymentTerm: IPaymentSpeed;
  handleChangePaymentTerm: (id: string) => void;
  handlePlaidSuccess: (publicToken: string, accounts: any[]) => void;
  handleUseFactoringCompany: VoidFunction;
  handleBankNotListed: VoidFunction;
};

export default function SelectDefaultPaymentSpeed({
  paymentTerms,
  selectedPaymentTerm,
  handleChangePaymentTerm,
  handlePlaidSuccess,
  handleUseFactoringCompany,
  handleBankNotListed
}: Readonly<SelectDefaultPaymentSpeedProps>) {
  const [isBankNotListed, setIsBankNotListed] = useState(false);

  return (
    <>
      <Select
        value={{
          id: 0,
          label: selectedPaymentTerm.name + ` (${selectedPaymentTerm.carrier_rate}% Quick Pay Fee)`,
          value: selectedPaymentTerm.id
        }}
        onChange={(term) => handleChangePaymentTerm(term.value)}
        options={paymentTerms.map((term) => ({
          id: term.payout_days,
          label: `${term.name} (${term.carrier_rate}% Quick Pay Fee)`,
          value: term.id
        }))}
        label="&nbsp;&nbsp;Default Payment Speed"
        className="desktop:mx-auto desktop:w-96"
      />

      <PlaidLinkComponent
        label="ADD YOUR BANK INFO"
        btnClass="!h-12"
        onPlaidSuccess={handlePlaidSuccess}
        onPlaidFailed={() => setIsBankNotListed(true)}
      />

      <span className={styles.decorationText}>OR</span>

      <button className={styles.goToSearchLink} onClick={handleUseFactoringCompany}>
        Use my Factoring Company
      </button>

      {isBankNotListed && (
        <Button
          variant="outline"
          rounded
          className="!h-12 desktop:!w-96 desktop:mx-auto"
          onClick={handleBankNotListed}>
          MY BANK IS NOT LISTED
        </Button>
      )}
    </>
  );
}
